import { Component } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';

import { WkErrorMessage } from '../../model/wk-error-response';
import { WkPasswordService } from '../../services/wk-password.service';

@Component({
  selector: 'wk-reset-password',
  templateUrl: './wk-reset-password.component.html',
  styleUrls: ['./wk-reset-password.component.scss'],
  standalone: false,
})
export class WkResetPasswordComponent {
  public submitted = false;
  public success = false;
  public failed = false;
  public failMessage: string;
  public isDisabled = false;
  public readonly backgroundUrlImageUrl =
    'url(./assets/images/Wallpaper-BG-generic.svg)';

  public formGroup = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
  });

  constructor(private readonly passwordService: WkPasswordService) {
    this.formGroup.valueChanges.subscribe(this.resetStates.bind(this));
  }

  public onSubmit(): void {
    this.isDisabled = true;
    this.submitted = true;

    if (this.formGroup.valid) {
      this.resetPassword();
    } else {
      this.isDisabled = false;
    }
  }

  private resetPassword(): void {
    this.resetStates();
    this.passwordService.resetPassword(this.formGroup.value).subscribe({
      next: () => {
        this.success = true;
        this.isDisabled = false;
      },
      error: (err: HttpErrorResponse): void => {
        this.failed = true;
        this.isDisabled = false;
        this.failMessage = (
          JSON.parse(err.message) as WkErrorMessage
        ).messageKey;
      },
    });
  }

  private resetStates(): void {
    this.failed = false;
    this.success = false;
    this.submitted = false;
  }
}
